import { COVERGO_SAAS_PROD } from "../consts.js"

export const platformLifeDemo = {
	// CoverGo PROD
	"platform-life-demo-studio.quote.hk": {
		appConfig: { tenantId: "platform_life_demo", appId: "covergo_crm" },
		envConfig: COVERGO_SAAS_PROD
	}
}
